// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__ZwkcK","tag--small":"tag_tag--small__EHkm-"};